module.exports = __webpack_public_path__ + "static/media/happy_christmas_map_important.74a2c840.svg";